/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { useState } from "react";
//@ts-ignore
import { Label, Input, Button } from "reactstrap";
import { v4 as uuidv4 } from "uuid";
import Icon from "rsuite/lib/Icon";
import { VApplication } from "../../../application";
import { StyleSheet } from "react-native";

//@ts-ignore
import merge from "lodash/merge";

import { DataSet } from "vis-data";

export const dynamicData = new DataSet({
    id: "dynamicId",
});

const is = require("is_js");

interface IFieldProps {
    name: string;
    label: string;
    keyFieldProps?: any;
    valueFieldProps?: any;
    labelStyle?: any;
    dynamicFieldContainerStyle?: any;
    [key: string]: any;
    formId?: string;
    disabled?: boolean;
}

const DynamicFieldsLib = (props: IFieldProps) => {
    const vapp = VApplication.getInstance();
    const storageService = vapp.getSync("services.StorageModule");
    const {
        name,
        label,
        valueFieldProps,
        keyFieldProps,
        labelStyle,
        dynamicFieldContainerStyle,
        formId,
        disabled,
    } = props;
    console.log("disabled dynamicfield", disabled);
    const [dynamicFields, setDynamicFields] = useState([
        { id: uuidv4(), key: "", value: "" },
    ]);

    // const defaultData = {
    //     id:uuidv4(),
    //     key:'',
    //     value:''
    // }

    // dynamicData.add([defaultData]);

    const addMoreField = () => {
        setDynamicFields([
            ...dynamicFields,
            { id: uuidv4(), key: "", value: "" },
        ]);
    };

    const removeField = (id) => {
        dynamicData.remove(id);
        const values = [...dynamicFields];
        values.splice(
            values.findIndex((value) => value.id === id),
            1
        );
        setDynamicFields(values);
        // dynamicData.update(values);
    };

    React.useState(() => {
        if (dynamicFields?.length === 1 && dynamicData.get()?.length >= 1) {
            let _data = dynamicData.get();
            setDynamicFields(_data);
        }
    }, [dynamicData.get()]);

    React.useEffect(() => {
        props.fieldValueChange && props.fieldValueChange(dynamicFields);
    }, [dynamicFields]);

    const _handleFieldValueChange = (id, event) => {
        dynamicData.remove();
        const newDynamicFields = dynamicFields?.map((i) => {
            if (id === i.id) {
                i[event.target.name] = event.target.value;
            }
            return i;
        });
        setDynamicFields(newDynamicFields);
        dynamicData.update(newDynamicFields);
        // props.fieldValueChange && props.fieldValueChange(dynamicFields);
    };

    const _getFormFields = () => {
        const dFields = dynamicFields;
        if (formId && formId === "update-gtin") {
            return (
                <>
                    {dFields.map((item, index) => (
                        <div
                            style={merge(
                                styles?.dynamicFieldContainerStyle,
                                dynamicFieldContainerStyle
                            )}
                            key={item.id}
                        >
                            <div style={{ paddingRight: 10 }}>
                                <Label
                                    style={merge(
                                        labelStyle,
                                        keyFieldProps?.labelStyle ?? {}
                                    )}
                                >
                                    {label}
                                </Label>
                                <Input
                                    {...{ ...(keyFieldProps || {}) }}
                                    type="text"
                                    disabled={
                                        item?.key &&
                                        item?.key.toLowerCase() === "gtin key"
                                            ? true
                                            : false
                                    }
                                    className="form-control"
                                    name="key"
                                    defaultValue={item.key}
                                    onChange={(event) =>
                                        _handleFieldValueChange(item?.id, event)
                                    }
                                />
                            </div>
                            <div style={{ paddingRight: 10 }}>
                                <Label
                                    style={merge(
                                        labelStyle,
                                        valueFieldProps?.labelStyle ?? {}
                                    )}
                                >
                                    {"Value"}
                                </Label>
                                <Input
                                    {...{ ...(valueFieldProps || {}) }}
                                    type="text"
                                    className="form-control"
                                    name={"value"}
                                    disabled={
                                        item?.key &&
                                        item?.key.toLowerCase() === "gtin key"
                                            ? true
                                            : false
                                    }
                                    //  value={item.value}
                                    defaultValue={item.value}
                                    onChange={(event) =>
                                        _handleFieldValueChange(item?.id, event)
                                    }
                                />
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "22px",
                                    columnGap: "15px",
                                }}
                            >
                                {index > 0 ? (
                                    <Icon
                                        icon="minus"
                                        style={{
                                            color: "#c4342d",
                                            fontSize: 20,
                                            cursor: "pointer",
                                        }}
                                        onClick={() => removeField(item.id)}
                                    />
                                ) : null}
                                {index === dFields?.length - 1 ? (
                                    <Icon
                                        icon="plus"
                                        style={{
                                            color: "#65c368",
                                            fontSize: 20,
                                            cursor: "pointer",
                                        }}
                                        onClick={addMoreField}
                                    />
                                ) : null}
                            </div>
                        </div>
                    ))}
                </>
            );
        } else {
            return (
                <>
                    {dFields.map((item, index) => (
                        <div
                            style={merge(
                                styles?.dynamicFieldContainerStyle,
                                dynamicFieldContainerStyle
                            )}
                            key={item.id}
                        >
                            <div style={{ paddingRight: 10 }}>
                                <Label
                                    style={merge(
                                        labelStyle,
                                        keyFieldProps?.labelStyle ?? {}
                                    )}
                                    dangerouslySetInnerHTML={{
                                        __html: item.label ?? label,
                                    }}
                                />
                                {/* //{item.label ?? label}
                                </Label> */}
                                <Input
                                    {...{ ...(keyFieldProps || {}) }}
                                    type="text"
                                    className="form-control"
                                    name="key"
                                    disabled={
                                        (item?.disableKey || disabled) ?? false
                                    }
                                    defaultValue={item.key}
                                    onChange={(event) =>
                                        _handleFieldValueChange(item?.id, event)
                                    }
                                />
                            </div>
                            <div style={{ paddingRight: 10 }}>
                                <Label
                                    style={merge(
                                        labelStyle,
                                        valueFieldProps?.labelStyle ?? {}
                                    )}
                                >
                                    {"Value"}
                                </Label>
                                <Input
                                    {...{ ...(valueFieldProps || {}) }}
                                    type="text"
                                    className="form-control"
                                    name={"value"}
                                    disabled={
                                        (item?.disableValue || disabled) ??
                                        false
                                    }
                                    value={item.value}
                                    defaultValue={item.value}
                                    onChange={(event) =>
                                        _handleFieldValueChange(item?.id, event)
                                    }
                                />
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "22px",
                                    columnGap: "15px",
                                }}
                            >
                                {index > 0 ? (
                                    <Icon
                                        icon="minus"
                                        style={{
                                            color: "#c4342d",
                                            fontSize: 20,
                                            cursor: "pointer",
                                        }}
                                        onClick={() =>
                                            disabled !== undefined &&
                                            disabled === true
                                                ? null
                                                : removeField(item.id)
                                        }
                                    />
                                ) : null}
                                {index === dFields?.length - 1 ? (
                                    <Icon
                                        icon="plus"
                                        style={{
                                            color: "#65c368",
                                            fontSize: 20,
                                            cursor: "pointer",
                                        }}
                                        onClick={
                                            disabled !== undefined &&
                                            disabled === true
                                                ? null
                                                : addMoreField
                                        }
                                    />
                                ) : null}
                            </div>
                        </div>
                    ))}
                </>
            );
        }
    };

    return (
        <div
            className="form-group"
            style={styles.containerStyle}
            disable={true}
        >
            {_getFormFields()}
        </div>
    );
};

const styles = {
    containerStyle: {
        paddingTop: 15,
    },
    dynamicFieldContainerStyle: {
        display: "flex",
        marginBlock: "10px",
        // width:"max-content"
    },
};

export default DynamicFieldsLib;
